const homepageData = {
  buttonText: "Find out more",
  tilesHeading: "Discover"
};

export default homepageData;
